import { MIconButton, MIcons } from "@material-dev/insights-portal-ui-components";
import MHelpDrawer from "@material-dev/insights-portal-ui-components/lib/feature-components/m-help-drawer/MHelpDrawer";
import { HelpDrawerItem, HelpDrawerSection } from "@material-dev/insights-portal-ui-components/lib/feature-components/m-help-drawer/types";
import React, { FC, memo } from "react";
import { useHeaderHelpItemStyles } from "./HeaderHelpItemStyles";
import { useAppDispatch, useAppSelector } from "@store";
import { closeHelpDrawer, openHelpDrawer } from "slices/dashboard/dashboardSlice";

const helpSections: HelpDrawerSection[] = [
  {
    title: 'Articles',
    items: [
      { type: 'link', label: 'Relevancy Checker', link: 'https://help.materialplus.io/a/solutions/articles/22000078726', iconTag:'RelevancyIcon' },
      { type: 'link', label: 'Similarity Checker', link: 'https://material.freshservice.com/support/solutions/articles/22000032362-Similarity-Checker', iconTag:'SimilarityCheckerIcon' },
      { type: 'link', label: 'SPSS Download', link: 'https://help.materialplus.io/a/solutions/articles/22000078725', iconTag:'SPSSDownloadIcon' },
      { type: 'link', label: 'Translations', link: 'https://help.materialplus.io/a/solutions/articles/22000069758', iconTag:'TranslationsIcon' },
    ],
  },
  {
    title: 'Product sheets',
    items: [
      { type: 'link', label: 'Data Manager', link: 'https://materialworkplace.sharepoint.com/sites/InsightsPortal/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FInsightsPortal%2FShared%20Documents%2FDocumentation%2FData%20Manager%2Fwip%2FDM%20Product%20Sheet%2Epdf&parent=%2Fsites%2FInsightsPortal%2FShared%20Documents%2FDocumentation%2FData%20Manager%2Fwip&p=true&ga=1', iconTag:'DataManagerIcon' },
      { type: 'link', label: 'Translations', link: 'https://materialworkplace.sharepoint.com/:b:/s/DataManager/EZpeTLsOBKJClR9AGxCS2fUBeWfBy9cY7I1LtN323b-KNw?e=KAbe7G', iconTag:'TranslationsIcon' },
      { type: 'link', label: 'Relevancy Checker', link: 'https://materialworkplace.sharepoint.com/:b:/s/DataManager/EZpeTLsOBKJClR9AGxCS2fUBeWfBy9cY7I1LtN323b-KNw?e=KAbe7G', iconTag:'RelevancyIcon' },
    ],
  }
];

const quickActions: HelpDrawerItem[] = [
  { type: 'link', label: 'Submit a helpdesk ticket', link: 'https://material.freshservice.com/support/tickets/new'  },
  { type: 'email', label: 'Contact us via email', link: 'mailto:datamanageradmin@materialplus.io' },
];

const HelpHeaderItem: FC = memo(() => {
  const { classes, cx } = useHeaderHelpItemStyles();
  const dispatch = useAppDispatch();
  const { helpDrawerOpen } = useAppSelector((state) => state.dashboard);

  return (
    <> 
      <MIconButton className={cx(classes.helpAction, { [classes.helpActionActive] : helpDrawerOpen })} onClick={()=>dispatch(openHelpDrawer())}><MIcons.HelpIcon className={classes.helpIcon} /></MIconButton>
      <MHelpDrawer
        className={classes.helpDrawer}
        anchor="right"
        open={helpDrawerOpen}
        title="Help"
        quickLinks={quickActions}
        sections={helpSections}
        onClose={()=>dispatch(closeHelpDrawer())}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "transparent",
            }
          }
        }}/>
    </>
  );
});

export default HelpHeaderItem;
